import { useT } from '_metronic/i18n/Metronici18n'
import { FetchState, useModal } from '../../../../../../components'
import { AtendimentoView } from '../../../../atendimento/core/_models'

type IProps = {
  isResponsavel?: boolean
}

export const AtendimentoDetalheModal = ({ isResponsavel }: IProps) => {
  const { fetchStates } = useModal()
  const { t } = useT()

  const { data: atendimento } = (fetchStates['atendimento'] || {}) as FetchState<AtendimentoView>

  return (
    <div className='row'>
      <div className='col-md-4 mb-3'>
        <div className='text-muted'>{t('agendamento.label')}</div>
        <div className='fw-bold'>{atendimento?.solicitacaoFormatada}</div>
      </div>

      <div className='col-md-4 mb-3'>
        <div className='text-muted'>{t('inicio.label')}</div>
        <div className='fw-bold'>{atendimento?.inicioFormatado}</div>
      </div>

      <div className='col-md-4 mb-3'>
        <div className='text-muted'>{t('termino.label')}</div>
        <div className='fw-bold'>{atendimento?.terminoFormatado}</div>
      </div>

      <div className='col-md-4 mb-3'>
        <div className='text-muted'>{t('retorno.label')}</div>
        <div className='fw-bold'>{atendimento?.retorno ? t('common.yes') : t('common.no')}</div>
      </div>

      <div className='col-md-4 mb-3'>
        <div className='text-muted'>{t('paciente.label')}</div>
        <div className='fw-bold'>{atendimento?.paciente?.nome}</div>
      </div>

      <div className='col-md-4 mb-3'>
        <div className='text-muted'>{t('especialidade.label')}</div>
        <div className='fw-bold'>{atendimento?.especialidade?.nome}</div>
      </div>
      {!isResponsavel && (
        <>
          <div className='col-md-4 mb-3'>
            <div className='text-muted'>
              {t('profissional.label')} {t('inicial.label')}
            </div>
            <div className='fw-bold'>{atendimento?.responsavelInicial?.nome}</div>
          </div>
          <div className='col-md-4 mb-3'>
            <div className='text-muted'>
              {t('profissional.label')} {t('final.label')}
            </div>
            <div className='fw-bold'>{atendimento?.responsavel?.nome}</div>
          </div>
        </>
      )}
    </div>
  )
}
